<script lang="ts">
  import type { Snippet } from 'svelte';
  import Button from '../components/ui/Button.svelte';
  import EmptyState from '../components/ui/EmptyState.svelte';
  import { getAppContext } from './context.js';

  interface Props {
    children?: Snippet;
  }

  let { children }: Props = $props();
  const { router } = getAppContext();

  function returnHome() {
    router.replace('home', {}, {
      flash: {
        title: 'Returned home',
        description: 'Your saved games are still available from the menu.',
      },
    });
  }
</script>

<svelte:boundary>
  {@render children?.()}

  {#snippet failed(error)}
    <div
      class="flex min-h-[50vh] items-center justify-center px-4 py-10"
      role="alert"
      data-testid="error-boundary"
    >
      <EmptyState
        title="Something went wrong"
        description={error instanceof Error ? error.message : "We couldn't complete that action. Your current game is unchanged."}
      >
        {#snippet action()}
          <Button onclick={returnHome}>Return Home</Button>
        {/snippet}
      </EmptyState>
    </div>
  {/snippet}
</svelte:boundary>
